import { FORM_CUADRO_DE_MANDO } from '../../../config/forms'
import CalleCalado from '../../../models/calado/calle_calado'
import CamionesPenalizados from '../../../models/camiones/camiones_penalizados'
import CuadroDeMando from '../../../models/dashboard/cuadro_de_mando'
import CuadroDeMandoCalado from '../../../models/dashboard/cuadro_de_mando_calado'
import CuadroDeMandoExpCereal from '../../../models/dashboard/cuadro_de_mando_exp_cereal'
import CuadroDeMandoIngresoCompleto from '../../../models/dashboard/cuadro_de_mando_ingreso_completo'
import ParametroInteger from '../../../models/parametro/parametro_integer'
import Matviews from '../../../models/tools/matviews'
import { consultaCalificacionPorCalleCalado, getCallesDeCaladoPorCerealHumedad, getCamionesCalados } from '../../Calado/actions'
import { consultaEstadoOcupacionCalles } from '../../Camiones/containers/listados/camionesCalados/actions/TablaCamionesCaladosActions'
import { obtenerVolcadorasConCerealAsignado, getCallesVolcadora } from '../../Volcadora/actions'
import { getFormValues } from 'redux-form'
import { toast } from 'react-toastify'
import moment from 'moment'
import { getDataPosiblesArribos } from '../components/posiblesArribos/actions/TablaPosiblesArribosActions'
import { getDataConsumidosEnViaje } from '../components/camionesEnTansito/actions/TablaCamionesEnTransitoActions'
import { CodigoDeCupo } from '../../../models/cupo/codigoDeCupo'

export function obtenerDatos () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getCuadroDeMando()
      .then((data) => dispatch({
        type: 'CUADRO_DE_MANDO',
        data
      }))
  }
}

export function obtenerDatosSilo () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getCuadroDeMando()
      .then((data) => dispatch({
        type: 'CUADRO_DE_MANDO',
        data
      }))
  }
}

export function obtenerDatosCuadroDeMandoIngresoCompleto () {
  return (dispatch) => {
    const cuadroDeMandoIC = new CuadroDeMandoIngresoCompleto()
    return cuadroDeMandoIC.getCuadroDeMandoIngresoCompleto()
      .then((data) => dispatch({
        type: 'CUADRO_DE_MANDO_INGRESO_COMPLETO',
        data
      }))
  }
}

export function obtenerTotales () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getTotalizadorCuadroDeMando()
      .then((data) => {
        console.log('data ', data)
        dispatch({ type: 'TOTALES_CUADRO_DE_MANDO', data })
      })
  }
}

export function obtenerConsultaProductividadAltaCom () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getProductividadAltaComCuadroDeMando()
      .then((data) => dispatch({
        type: 'PRODUCTIVIDAD_ALTA',
        data
      }))
  }
}

export function obtenerConsultaProductividadAltaCompleta () {
  return (dispatch) => {
    const cuadroDeMandoIC = new CuadroDeMandoIngresoCompleto()
    return cuadroDeMandoIC.getProductividadAltaComCuadroDeMandoIngresoCompleto()
      .then((data) => dispatch({
        type: 'PRODUCTIVIDAD_ALTA_COMPLETA',
        data
      }))
  }
}

export function obtenerConsultaProductividadIngreso () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getProductividadIngresoCuadroDeMando()
      .then((d) => {
        let data
        if (d.filas_procesadas > 0) {
          data = d.filas
        } else {
          data = null
        }

        dispatch({
          type: 'PRODUCTIVIDAD_INGRESO',
          data
        })
      })
  }
}

export function obtenerConsultaProductividadCalado () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getProductividadCaladoCuadroDeMando()
      .then((d) => {
        let data
        if (d.filas_procesadas > 0) {
          data = d.filas
        } else {
          data = null
        }
        dispatch({
          type: 'PRODUCTIVIDAD_CALADO',
          data
        })
      })
  }
}

export function parseData (d) {
  let data
  if (d.filas_procesadas > 0) {
    data = d.filas
  } else {
    data = null
  }
  return data
}

export function obtenerConsultaProductividadBruto () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getProductividadBrutoCuadroDeMando()
      .then(async (d) => {
        const data = await parseData(d)
        dispatch({
          type: 'PRODUCTIVIDAD_BRUTO',
          data
        })
      })
  }
}

export function obtenerConsultaProductividadDestare () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getProductividadDestareCuadroDeMando()
      .then(async (d) => {
        const data = await parseData(d)
        dispatch({
          type: 'PRODUCTIVIDAD_DESTARE',
          data
        })
      })
  }
}

export function obtenerConsultaProductividadVolcadora () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getProductividadVolcadoraCuadroDeMando()
      .then((data) => dispatch({
        type: 'PRODUCTIVIDAD_VOLCADORA',
        data
      }))
  }
}

export function obtenerConsultaCuposStopQ () {
  return (dispatch) => {
    const cuadroDeMando = new CuadroDeMando()
    return cuadroDeMando.getCuposStopQCuadroDeMando()
      .then((data) => dispatch({
        type: 'CUPOS_STOPQ',
        data
      }))
  }
}

export function obtenerDatosCdmdExpCereal () {
  return (dispatch) => {
    const cuadroDeMandoExpCereal = new CuadroDeMandoExpCereal() // Intancia de la clase en Models
    return cuadroDeMandoExpCereal.getCdmdExpCereal()
      .then((data) => dispatch({
        type: 'CUADRO_DE_MANDO_EXP_CEREAL', // Nombre indicado en el Reducer
        data
      }))
  }
}

export function obtenerDatosCdmdCereal () {
  return (dispatch) => {
    const cuadroDeMandoExpCereal = new CuadroDeMandoExpCereal() // Intancia de la clase en Models
    return cuadroDeMandoExpCereal.getCdmdCereal()
      .then((data) => dispatch({
        type: 'CUADRO_DE_MANDO_CEREAL', // Nombre indicado en el Reducer
        data
      }))
  }
};

// export function obtenerDatosCamionesCaladosTotalExp () {
//   return (dispatch, getState) => {
//     const camionesCalados = new CuadroDeMandoCalado()
//     return camionesCalados.getCamionesCaladosTotalExp()
//       .then((data) => dispatch({
//         type: 'CAMIONES_CALADOS_TOTAL_EXP',
//         data
//       }))
//   }
// }

// export function obtenerDatosCamionesCaladosTotalPerito () {
//   return (dispatch, getState) => {
//     const camionesCalados = new CuadroDeMandoCalado()
//     return camionesCalados.getCamionesCaladosTotalPerito()
//       .then((data) => dispatch({
//         type: 'CAMIONES_CALADOS_TOTAL_PERITO',
//         data
//       }))
//   }
// };

// export function obtenerDatosCamionesCaladosTotalCalif () {
//   return (dispatch, getState) => {
//     const camionesCalados = new CuadroDeMandoCalado()
//     return camionesCalados.getCamionesCaladosTotalCalif()
//       .then((data) => dispatch({
//         type: 'CAMIONES_CALADOS_TOTAL_CALIF',
//         data
//       }))
//   }
// };

export function obtenerDatosHistogramaCaladoPuesto () {
  return (dispatch) => {
    const histogramaCaladoPorPuesto = new CuadroDeMandoCalado()
    return histogramaCaladoPorPuesto.getHistogramaCaladoPuesto()
      .then((data) => dispatch({
        type: 'HISTOGRAMA_CALADO_PUESTO',
        data
      }))
  }
};

export function consultaEstadoOcupacionCallesCalado () {
  return (dispatch) => {
    const consultaEstadoOcupacion = new CalleCalado()
    return consultaEstadoOcupacion.getConsultaEstadoOcupacionCallesCalado()
      .then((data) => dispatch({
        type: 'ESTADO_CALLES_CALADO',
        data
      }))
  }
};

export function estadoOcupacionCallesDeCalado () {
  return consultaEstadoOcupacionCalles()
}

export function callesDeCaladoPorCerealHumedad () {
  return getCallesDeCaladoPorCerealHumedad()
}

export function obtenerCamionesCalados () {
  return getCamionesCalados()
}

export function calificacionCalleDeCalado () {
  return consultaCalificacionPorCalleCalado()
}

export function obtenerCerealAsignadoAVolcadora () {
  return obtenerVolcadorasConCerealAsignado()
}

export function obtenerCallesVolcadora () {
  return getCallesVolcadora()
}

export function updateParametroInteger (nombre, value) {
  return dispatch => {
    return ParametroInteger.updateByNombre(nombre, value)
  }
}

export function obtenerEstadoCTGPostergada () {
  return (dispatch) => {
    return ParametroInteger.getByNombre('WSCTGPOS')
      .then((wsctg) => {
        dispatch({ type: 'ESTADO_CTG_POSTERGADA', wsctg })
      })
  }
}

export function updateEstadoCTGPostergada (newValue) {
  return (dispatch) => {
    dispatch(updateParametroInteger('WSCTGPOS', newValue))
      .then(() => {
        dispatch(obtenerEstadoCTGPostergada())
      })
  }
}

export function obtenerDuracionDeVolcado () {
  return (dispatch) => {
    return ParametroInteger.getByNombre('DURVOLCA')
      .then((duracionVolcado) => {
        dispatch({ type: 'DURACION_VOLCADO', duracionVolcado })
      })
  }
}

export function updateDuracionDeVolcado (newValue) {
  return (dispatch) => {
    dispatch(updateParametroInteger('DURVOLCA', newValue))
      .then(() => {
        dispatch(obtenerDuracionDeVolcado())
      })
  }
}

export function getActCamionesCircuito () {
  return (dispatch) => {
    return Matviews.getStatusMatview('cdmd_exportador_cereal_todos')
      .then((estado) => {
        dispatch({ type: 'ESTADO_MV_CAMIONES_CIRCUITO', estado })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function getActRemitosTotal () {
  return (dispatch) => {
    return Matviews.getStatusMatview('cdmd_remitos_total')
      .then((estado) => {
        dispatch({ type: 'ESTADO_MV_REMITOS_TOTAL', estado })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function getActCamionesExpCereal () {
  return (dispatch) => {
    return Matviews.getStatusMatview('cdmd_exportador_cereal')
      .then((estado) => {
        dispatch({ type: 'ESTADO_MV_EXP_CEREAL', estado })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function submitPenalizacionCamion () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUADRO_DE_MANDO)(state)
    const fechaPenalizacion = (new Date()).toISOString()
    const patente = formValues.penalizacionPatente
    const vencimiento = formValues.penalizacionVencimiento
    const motivo = formValues.penalizacionMotivo
    CamionesPenalizados.insertPenalizacionCamion(fechaPenalizacion, patente, vencimiento, motivo)
      .then((result) => {
        if (!result.error) {
          dispatch({ type: 'PENALIZACION_CAMION' })
          toast.success(`La patente ${patente} fue penalizada hasta el ${vencimiento} correctamente.`)
        } else {
          toast.error('Error al intentar penalizar la pantente.')
          console.log('Error: ', result.message)
        }
      })
      .catch((e) => {
        console.log(e)
        toast.error('Error al intentar penalizar la pantente.')
      })
  }
}

export function submitPenalizacionAcoplado () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUADRO_DE_MANDO)(state)
    const fechaPenalizacion = (new Date()).toISOString()
    const patente = formValues.penalizacionPatente
    const vencimiento = formValues.penalizacionVencimiento
    const motivo = formValues.penalizacionMotivo
    CamionesPenalizados.insertPenalizacionAcoplado(fechaPenalizacion, patente, vencimiento, motivo)
      .then((result) => {
        if (!result.error) {
          dispatch({ type: 'PENALIZACION_ACOPLADO' })
          toast.success(`La patente ${patente} fue penalizada hasta el ${vencimiento} correctamente.`)
        } else {
          toast.error('Error al intentar penalizar la pantente.')
          console.log('Error: ', result.message)
        }
      })
      .catch((e) => {
        console.log(e)
        toast.error('Error al intentar penalizar la pantente.')
      })
  }
}

export function obtenerPosiblesArribos (fechaD, fechaH) {
  return getDataPosiblesArribos(fechaD, fechaH)
}

export function obtenerCodigosDeCupo (fechaD, fechaH) {
  return getDataCodigosDeCupo(fechaD, fechaH)
}

export function obtenerConsumidosEnViaje () {
  return getDataConsumidosEnViaje()
}

export function setUltimaActualizacionCDMD () {
  return (dispatch) => {
    const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
    dispatch({ type: 'ULTIMA_ACTUALIZACION_CDMD', fecha })
  }
}

export function getDataCodigosDeCupo (fechaD, fechaH) {
  return (dispatch) => {
    CodigoDeCupo.getDataTablaConsultaCodigoDeCuposFiltrada(fechaD, fechaH, null, null)
      .then((data) => {
        const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
        return dispatch({ type: 'RECEIVE_CODIGOS_DE_CUPO', data, fecha })
      })
  }
}
